import React, { useEffect, useState } from "react";
import classes from "./ClientAdminTable.module.scss";
import { deepOrange, deepPurple } from "@mui/material/colors";
import DataTable from "react-data-table-component";
import Avatar from "@mui/material/Avatar";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import MailIcon from "@mui/icons-material/Mail";
import SearchIcon from "@mui/icons-material/Search";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { useDropzone } from "react-dropzone";
import {
  AssignUserAPICall,
  GetAllCompanyAPICall,
  GetAllPlansAPICall,
  GetUsersAPICall,
  clientAdminProfileApi,
  clientAdminTableApi,
  clientUploadAndResetApi,
  clientUploadApi,
} from "../../Utils/Apihelper";
import StyledLoader from "../../components/Styledloader/StyledLoader";
import {
  Button,
  FormControl,
  IconButton,
  InputLabel,
  Select,
  SelectChangeEvent,
  Stack,
  ThemeProvider,
  Tooltip,
} from "@mui/material";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import Pagination from "@mui/material/Pagination";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setProfile } from "../../Store/Project/ProjectSlice";
import { Toaster, toast } from "react-hot-toast";
import phoneimage from "../../assets/Images/phonevector.svg";
import emailimage from "../../assets/Images/emailvector.svg";
import { theme } from "../../components/ThemeProvider/ThemeProvider";
import { IAssignUser, IGetAllCompany } from "../../Utils/dtos";
import AutoCompleteUser from "../../components/AutoComplete/AutoComplete";
import PersonIcon from "@mui/icons-material/Person";
import AssignUser from "../../components/Modals/AssignUser";
import { Helmet } from "react-helmet";

let randomClr = Math.floor(Math.random() * 16777215).toString(16);

// const filteredData = data.filter((email) =>
// email.tradeCode.toLowerCase().includes(query)  || email.tradeCode.toUpperCase().includes(query)
// );

const ClientAdmin = () => {
  const [selectedFile, setSelectedFile] = React.useState(null);
  const accepectedFileTypes = ".csv";

  const [openUpload, setOpenUpload] = React.useState(false);
  const [query, setQuery] = useState("");
  const [data, setData] = useState([]);

  const [page, setPage] = useState(1);
  const [rowslimit, setRowsLimit] = useState(30);
  const [loading, setloading] = useState(false);
  const [paginationCount, setpaginationCount] = useState(1);
  const [totalRows, setTotalRows] = useState(5);
  const [disableUpload, setdisableUpload] = React.useState(false);
  const [clear, setclear] = useState(false);
  const [users, setUsers] = useState([]);
  const [plan, setplan] = useState("All");
  const [userDetails, setUserDetails] = useState({
    id: "",
    name: "",
    email: "",
    mobile: "",
    isActive: false,
    isAdmin: false,
  });
  const [openAssignUser, setOpenAssignUser] = useState(false);
  const [companyname, setCompanyName] = useState("");
  const [plansData, setPlansData] = useState<any>([]);
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
    GetALLCompanyDetails();
  }, [page, query, plan]);

  useEffect(() => {
    GetUsers();
    GetAllPlans();
  }, []);

  const GetALLCompanyDetails = () => {
    let obj: IGetAllCompany = {
      query: query,
      pageNo: page,
      pageLimit: 20,
      plan: plan,
    };
    setloading(true);
    GetAllCompanyAPICall(obj)
      .then((response: any) => {
        // console.log("response", response.data.data.data);
        setloading(false);
        setData(response.data.data.data ? response.data.data.data : []);
        setTotalRows(Math.ceil(response.data.data.totalrecords / 20));
      })
      .catch((error: any) => {
        setloading(false);
        // console.log("error", error);
      });
  };

  const GetAllPlans = () => {
    GetAllPlansAPICall()
      .then((response: any) => {
        console.log("response", response.data.data);

        const filtered: any = response.data.data.filter(
          (a: any) => a.product === "email"
        );

        setPlansData([{ planName: "All" },...filtered ]);
      })
      .catch((error) => {});
  };
  const GetUsers = () => {
    GetUsersAPICall()
      .then((response: any) => {
        setUsers(response.data.data ? response.data.data : []);
      })
      .catch((error: any) => {});
  };

  const handleRowClick = (row: any) => {
    console.log("Clicked row:", row);
    sessionStorage.setItem("companyName", row.companyDetails.companyName);
    navigate("/dashboard/clients/clientDetails");
  };

  const handlePageChange = (value: any, page: any) => {
    window.scrollTo(0, 0);
    setpaginationCount(page);
    setPage(page);
  };
  const handleAssignePopUpClose = () => {
    setOpenAssignUser(false);
  };

  const handleAssigneID = (data: any) => {
    let obj: IAssignUser = {
      companyName: companyname,
      userName: data,
    };

    AssignUserAPICall(obj)
      .then((response: any) => {
        setOpenAssignUser(false);
        toast.success("User Assigned Successfully");
        GetALLCompanyDetails();
      })
      .catch((error: any) => {
        setOpenAssignUser(false);
        toast.error("Error Assigning User");
      });
  };

  function formatDate(inputDate: any) {
    const date = new Date(inputDate);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const ampm = date.getHours() >= 12 ? "PM" : "AM";

    return `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;
  }

  const handleAssign = (data: any) => {
    setOpenAssignUser(true);
    setCompanyName(data.companyDetails.companyName);
  };

  const columns: any = [
    {
      name: (
        <b style={{ fontSize: "15px", fontWeight: "bolder", color: "#2D3748" }}>
          SrNo
        </b>
      ),
      selector: "srno",
      sortable: true,
      width: "70px",
      cell: (row: any, index: any) => (
        <b style={{ fontSize: "14px", color: "#2D3748", fontWeight: 600 }}>
          {index + 1 + paginationCount * 20 - 20}
        </b>
      ),
    },
    {
      name: (
        <b style={{ fontSize: "15px", fontWeight: "bolder", color: "#2D3748" }}>
          Name
        </b>
      ),

      selector: "companyName",
      sortable: true,

      cell: (row: any) => (
        <b
          style={{ fontSize: "14px", color: "#2D3748", fontWeight: 600 }}
          onClick={() => handleRowClick(row)}
        >
          {row.companyDetails.companyName}
        </b>
      ),
    },
    {
      name: (
        <b style={{ fontSize: "15px", fontWeight: "bolder", color: "#2D3748" }}>
          Mobile
        </b>
      ),

      selector: "contactNumber",
      sortable: true,

      cell: (row: any) => (
        <b
          style={{ fontSize: "14px", color: "#2D3748", fontWeight: 600 }}
          onClick={() => handleRowClick(row)}
        >
          {row.contactNumber}
        </b>
      ),
    },
    {
      name: (
        <b style={{ fontSize: "15px", fontWeight: "bolder", color: "#2D3748" }}>
          Email
        </b>
      ),

      selector: "email",
      sortable: true,

      cell: (row: any) => (
        <b
          style={{ fontSize: "14px", color: "#2D3748", fontWeight: 600 }}
          onClick={() => handleRowClick(row)}
        >
          {row.email}
        </b>
      ),
    },

    {
      name: (
        <b style={{ fontSize: "15px", fontWeight: "bolder", color: "#2D3748" }}>
          Created TS
        </b>
      ),

      selector: "createdAt",
      sortable: true,

      cell: (row: any) => (
        <b
          style={{ fontSize: "14px", color: "#2D3748", fontWeight: 600 }}
          onClick={() => handleRowClick(row)}
        >
          {row.createdAt.length > 0 ? formatDate(row.createdAt) : row.createdAt}
        </b>
      ),
    },
    {
      name: (
        <b style={{ fontSize: "15px", fontWeight: "bolder", color: "#2D3748" }}>
          Plan
        </b>
      ),

      selector: "subscriptionType",
      sortable: true,
      width: "80px",
      cell: (row: any) => (
        <b
          style={{ fontSize: "14px", color: "#2D3748", fontWeight: 600 }}
          onClick={() => handleRowClick(row)}
        >
          {row.subscription.subscriptionType}
        </b>
      ),
    },
    {
      name: (
        <b style={{ fontSize: "15px", fontWeight: "bolder", color: "#2D3748" }}>
          Expiry
        </b>
      ),

      selector: "subscriptionExpiry",
      sortable: true,

      cell: (row: any) => (
        <b
          style={{ fontSize: "14px", color: "#2D3748", fontWeight: 600 }}
          // onClick={() => handleRowClick(row)}
        >
          {row.subscription.subscriptionExpiry}
        </b>
      ),
    },
    {
      name: (
        <b style={{ fontSize: "15px", fontWeight: "bolder", color: "#2D3748" }}>
          User
        </b>
      ),

      selector: "assignedUser",
      sortable: true,

      cell: (row: any) => (
        <>
          {row.assignedUser === "" ? (
            <Tooltip title="Assign User ">
              <IconButton
                onClick={() => {
                  handleAssign(row);
                }}
              >
                <PersonIcon />
              </IconButton>
            </Tooltip>
          ) : (
            <b
              style={{ fontSize: "12px", cursor: "pointer" }}
              onClick={() => {
                handleAssign(row);
              }}
            >
              {row.assignedUser}
            </b>
          )}
        </>
      ),
    },
    {
      name: (
        <b style={{ fontSize: "15px", fontWeight: "bolder", color: "#2D3748" }}>
          Status
        </b>
      ),
      selector: "subscriptionStatus",
      sortable: true,
      cell: (row: any) => (
        <div
          className={
            row.subscription.subscriptionStatus
              ? classes.statusGreen
              : classes.statusOrange
          }
          onClick={() => {
            handleRowClick(row);
          }}
        >
          <b style={{ fontSize: "13px" }}>
            {row.subscription.subscriptionStatus ? "Active" : "Inactive"}
          </b>
        </div>
      ),
    },
  ];

  const customStyles = {
    headCells: {
      style: {
        backgroundColor: "#F3F6FA",
        // display: "flex",
        // justifyContent: "center",
        // alignItems: "center",
      },
    },

    headRow: {
      style: {
        borderBottom: "none",
        marginBottom: "10px",
      },
    },
    header: {
      style: {
        fontSize: "16px",
        minHeight: "38px",
        paddingLeft: "5px",
        paddingRight: "5px",
      },
    },
    contextMenu: {
      style: {
        fontSize: "14px",
        fontWeight: 400,
        paddingLeft: "16px",
        paddingRight: "8px",
        transform: "translate3d(0, -100%, 0)",
        transitionDuration: "125ms",
        transitionTimingFunction: "cubic-bezier(0, 0, 0.2, 1)",
        willChange: "transform",
      },
      activeStyle: {
        transform: "translate3d(0, 0, 0)",
      },
      rows: {
        style: {
          cursor: "pointer",
          fontSize: "13px",
          fontWeight: 400,
          backgroundColor: "red",
          minHeight: "48px",
          "&:not(:last-of-type)": {
            borderBottomStyle: "solid",
            borderBottomWidth: "1px",
          },
        },
      },
    },
    cells: {
      style: {
        paddingTop: "16px",
        paddingBottom: "16px",
        wordBreak: "break-word",
        cursor: "pointer",
      },
      draggingStyle: {},
    },
  };

  const handleChange = (event: SelectChangeEvent) => {
    setplan(event.target.value as string);
  };

  const handleClear = () => {
    setplan("All");
    setUserDetails({
      id: "",
      name: "",
      email: "",
      mobile: "",
      isActive: false,
      isAdmin: false,
    });
    setPage(1);
    setQuery("");
  };
  return (
    <>
      <Helmet>
        <title>Clients </title>
        <meta name="Clients" content="Clients" />
      </Helmet>
      <ThemeProvider theme={theme}>
        <Toaster />
        <div className={classes.wrapper}>
          <div className={classes.topbar}>
            <div className={classes.searchInput}>
              <div className={classes.searchIcon}>
                <SearchIcon sx={{ fill: "black" }} />
              </div>

              <input
                type="text"
                value={query}
                className={classes.inputBox}
                placeholder="Search...."
                onChange={(e) => setQuery(e.target.value)}
              />
            </div>
            <div style={{ width: "300px" }}>
              <AutoCompleteUser
                data={users}
                userName={userDetails}
                setuserName={setUserDetails}
              />
            </div>
            <div>
              <FormControl fullWidth>
                <InputLabel
                  id="demo-simple-select-label"
                  sx={{ marginTop: "12px" }}
                >
                  Plan
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={plan}
                  label="Plan"
                  onChange={handleChange}
                  size="small"
                  sx={{
                    marginTop: "12px",
                    borderRadius: "10px",
                    width: "150px",
                    background: "#EDF2F7",
                    outline: "none",
                    fontSize: "16px",
                    fontWeight: 500,
                    padding: "0 10px",
                    color: "#000000",
                    boxShadow: "none",
                    "& .MuiOutlinedInput-input": {
                      // padding: "4.5px 4px 2.5px 8px",
                      cursor: "pointer",
                      border: 0,
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: 0,
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      border: 0,
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      border: 0,
                    },
                  }}
                >
                  {plansData.map((a: any) => (
                    <MenuItem value={a.planName}>{a.planName}</MenuItem>
                  ))}

                  {/* <MenuItem value={"Basic"}>Basic</MenuItem>
                  <MenuItem value={"Premium"}>Premium</MenuItem> */}
                </Select>
              </FormControl>
            </div>
            <div>
              <Button variant="contained" onClick={handleClear}>
                Clear
              </Button>
            </div>
          </div>
          <div className={classes.tablewrapper}>
            <DataTable
              columns={columns}
              data={data}
              fixedHeader
              customStyles={customStyles}
              progressPending={loading}
              progressComponent={<StyledLoader />}
              onRowClicked={(row) => {
                handleRowClick(row);
              }}
            />
          </div>
          {data.length > 0 && (
            <Stack
              alignItems={"center"}
              marginTop={"20px"}
              marginBottom={"20px"}
            >
              <Pagination
                onChange={(value, page) => {
                  handlePageChange(value, page);
                  // setpaginationCount(page);
                }}
                page={paginationCount}
                count={totalRows}
                variant="outlined"
                shape="rounded"
              />
            </Stack>
          )}
        </div>

        <AssignUser
          open={openAssignUser}
          handleClose={handleAssignePopUpClose}
          assigneID={handleAssigneID}
          userData={users}
        />
      </ThemeProvider>
    </>
  );
};

export default ClientAdmin;
